// const index = 0;
const colorList = ['#FE9B37', '#48DA26', '#1C6EFB', '#F40F5D', '#98F8FF'];
// function fun() {
//   const timer = setInterval(() => {
//     myChart.dispatchAction({
//       type: 'hideTip',
//       seriesIndex: 0,
//       dataIndex: index
//     });
//     // 显示提示框
//     myChart.dispatchAction({
//       type: 'showTip',
//       seriesIndex: 0,
//       dataIndex: index
//     });
//     // 取消高亮指定的数据图形
//     myChart.dispatchAction({
//       type: 'downplay',
//       seriesIndex: 0,
//       dataIndex: index === 0 ? 5 : index - 1
//     });
//     myChart.dispatchAction({
//       type: 'highlight',
//       seriesIndex: 0,
//       dataIndex: index
//     });
//     index++;
//     if (index > 5) {
//       index = 0;
//     }
//   }, 3000);
// }

// fun();
// setTimeout(() => { fun(); }, 5000);

export default {
  title: {
    // show: false,
    text: '',
    x: 'center',
    y: '55%',
    textStyle: {
      fontSize: 16,
      color: '#fff'
    }
  },
  tooltip: {
    trigger: 'item',
    formatter: '{b}：{c}%'
  },
  series: [{
    type: 'pie',
    center: ['50%', '60%'],
    radius: ['40%', '60%'],
    clockwise: true,
    avoidLabelOverlap: true,
    hoverOffset: 8,
    itemStyle: {
      normal: {
        color(params) {
          return colorList[params.dataIndex];
        }
      }
    },
    label: {
      show: true,
      position: 'outside',
      // formatter: '{a|{b}：{d}%}\n{hr|}',
      formatter: '{a|{b}：{c}%}\n{hr|}',
      fontSize: 12,
      fontWeight: 400,
      rich: {
        hr: {
          // backgroundColor: 't',
          // borderRadius: 3,
          // width: 3,
          // height: 3,
          // padding: [3, 3, 0, -12]
        },
        // a: {
        //   padding: [-30, 15, -20, 15]
        // }
      }
    },
    labelLine: {
      normal: {
        length: 10,
        length2: 15,
        // smooth: true,
        lineStyle: {
          // color: '#fff',
          width: 1
        }
      }
    },
    data: [{
      name: '现金',
      value: 9.6
    }, {
      name: '支付宝',
      value: 8.9
    }, {
      name: '刷卡',
      value: 6.3
    }, {
      name: '微信',
      value: 16.7
    }],
  }]
};
